import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _challengeStats = {
    published: '_publishedChallengeStats',
    finished: '_finishedChallengeStats',
};
var _finishedChallengeStats = { completionRate: 'DOUBLE' };
var _getChallengeStatsRequest = {};
var _getChallengeStatsResponse = { challengeStats: '_challengeStats' };
var _getPremiumStatsRequest = {};
var _getPremiumStatsResponse = { stats: '_premiumStats' };
var _getQuizzesStatsRequest = {};
var _getQuizzesStatsResponse = {};
var _getStatsRequest = {};
var _getStatsResponse = {};
var _premiumStats = { gracePeriodEnd: 'google.protobuf.Timestamp' };
var _publishedChallengeStats = { completionRate: 'DOUBLE' };
function resolveComWixpressAchievementsApiV1StatsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/challenge-service-web',
                destPath: '',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v2',
                destPath: '/v2',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
            {
                srcPath: '/challenges/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v2',
                destPath: '/v2',
            },
        ],
        _: [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
            {
                srcPath: '/challenges/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v2',
                destPath: '/v2',
            },
        ],
        'challenges.wixapps.net': [
            {
                srcPath: '/challenge-service-web/api',
                destPath: '',
            },
            {
                srcPath: '/challenge-service-web/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/api/v1',
                destPath: '/api/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v2',
                destPath: '/v2',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
            {
                srcPath: '/challenge-service-web/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/challenge-service-web/api/v2',
                destPath: '/v2',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/challenge-service-web',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function getStats(payload) {
    var _a = serializer(_getStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStatsResponse, {}).fromJSON;
    function __getStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge_stats',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.StatsService.GetStats',
            url: resolveComWixpressAchievementsApiV1StatsServiceUrl({
                protoPath: '/api/v1/stats',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStats.fromReq = fromReq;
    return __getStats;
}
getStats.__isAmbassador = true;
export function getChallengeStats(payload) {
    var _a = serializer(_getChallengeStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getChallengeStatsResponse, {
        _challengeStats: _challengeStats,
        _finishedChallengeStats: _finishedChallengeStats,
        _publishedChallengeStats: _publishedChallengeStats,
    }).fromJSON;
    function __getChallengeStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge_stats',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.StatsService.GetChallengeStats',
            url: resolveComWixpressAchievementsApiV1StatsServiceUrl({
                protoPath: '/api/v1/stats/{challengeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1StatsServiceUrl({
                        protoPath: '/api/v1/stats/{challengeId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getChallengeStats.fromReq = fromReq;
    return __getChallengeStats;
}
getChallengeStats.__isAmbassador = true;
export function getQuizzesStats(payload) {
    var _a = serializer(_getQuizzesStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getQuizzesStatsResponse, {}).fromJSON;
    function __getQuizzesStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge_stats',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.StatsService.GetQuizzesStats',
            url: resolveComWixpressAchievementsApiV1StatsServiceUrl({
                protoPath: '/api/v1/stats/quizzes/{challengeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressAchievementsApiV1StatsServiceUrl({
                        protoPath: '/api/v1/stats/quizzes/{challengeId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getQuizzesStats.fromReq = fromReq;
    return __getQuizzesStats;
}
getQuizzesStats.__isAmbassador = true;
export function getPremiumStats(payload) {
    var _a = serializer(_getPremiumStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPremiumStatsResponse, {
        _premiumStats: _premiumStats,
    }).fromJSON;
    function __getPremiumStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.challenges.v1.challenge_stats',
            method: 'GET',
            methodFqn: 'com.wixpress.achievements.api.v1.StatsService.GetPremiumStats',
            url: resolveComWixpressAchievementsApiV1StatsServiceUrl({
                protoPath: '/api/v1/premium-stats',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPremiumStats.fromReq = fromReq;
    return __getPremiumStats;
}
getPremiumStats.__isAmbassador = true;
//# sourceMappingURL=http.impl.js.map